if(typeof _GIRL_CONF['cindy']['game_memory']=='undefined'){_GIRL_CONF['cindy']['game_memory']={};};
_GIRL_CONF['cindy']['game_memory']['face']={left:542,top:163,width:126,height:165};
_GIRL_CONF['cindy']['game_memory']['hair']={left:496,top:46,width:264,height:406};
_GIRL_CONF['cindy']['game_memory']['handl']={left:502,top:314,width:203,height:169};
_GIRL_CONF['cindy']['game_memory']['handr']={left:697,top:186,width:97,height:289};
_GIRL_CONF['cindy']['game_memory']['item1']={left:200,top:263,width:197,height:378};
_GIRL_CONF['cindy']['game_memory']['item2']={left:961,top:408,width:146,height:293};
_GIRL_CONF['cindy']['game_memory']['item3']={left:343,top:536,width:594,height:138};
_GIRL_CONF['cindy']['game_memory']['knee1']={left:511,top:453,width:113,height:75};
_GIRL_CONF['cindy']['game_memory']['knee2']={left:659,top:458,width:104,height:72};
